import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import * as firebase from "firebase";

import Login from "./login";
import Registration from "./registration";
import Staff from "./staff";
import Customer from "./customer";
import { withFirebase } from "./data/index";

class AppRouter extends React.Component {
  componentDidMount() {
    // Globally listen for authentication changes
    firebase.auth().onAuthStateChanged(user => {
      if (!user && window.location.pathname !== "/") {
        window.location = "/";
      }
    });

    //reload when there is version update
    let counter = 0;
    firebase.database().ref("app/version").on("value", () => {
      //ignore first event when app initially load
      counter++;
      if (counter > 1) {
        window.location.reload();
      }
    });
  }

  render() {
    return (
      <Router>
        <div>
          <Switch>
            <Route exact path={"/"} component={Login} />
            <Route path="/registration/:step*" component={Registration} />
            <Route exact path={"/staff"} component={Staff} />
            <Route path={"/customer/:customerId*"} component={Customer} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default withFirebase(AppRouter, ["locations", "administrators"]);



// WEBPACK FOOTER //
// ./src/router.js